import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import AdminPanelSummary from '../components/AdminPanelSummary';
import gameCatalog from '../games/catalog';

const GameLibraryPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  const displayName = user?.displayName || user?.username || '玩家';

  return (
    <main className="page-shell page-shell--themed game-library-page">
      <header className="library-header">
        <div className="header-content">
          <div className="logo-group">
            <span className="logo-icon"></span>
            <span className="logo-divider">/</span>
            <h1>大足游戏馆<span style={{ display: 'none' }}>游戏库</span></h1>
          </div>
          <div className="user-profile">
            <span className="user-greeting">你好, {displayName}</span>
            <button className="apple-logout-btn" type="button" onClick={handleLogout}>
              退出登录
            </button>
          </div>
        </div>
      </header>

      {user?.role === 'admin' && (
        <div className="admin-wrapper animate-fade-in" style={{ padding: '0 24px', margin: '20px auto 0 auto', maxWidth: '1200px' }}>
          <AdminPanelSummary />
        </div>
      )}

      <section className="games-grid" aria-label="游戏目录" style={{ marginTop: '36px' }}>
        {gameCatalog.map((game, index) => {
          const isHoldem = game.id === 'holdem';
          const cardClass = isHoldem ? 'game-card--holdem' : 'game-card--gomoku';
          const delay = `${0.1 + index * 0.15}s`;

          return (
            <article
              key={game.id}
              className={`game-card ${cardClass} animate-fade-in-up`}
              style={{ animationDelay: delay }}
            >
              <div className="game-card__visual-bg" />
              <div className="game-card__content">
                <h3 className="game-card__title" style={{ fontSize: '28px', marginBottom: '16px' }}>{game.summary}</h3>

                <div className="game-card__action-zone">
                  {game.available ? (
                    <Link className="apple-cta-button" to={game.path}>
                      {game.ctaLabel} <span className="arrow">→</span>
                    </Link>
                  ) : (
                    <span className="apple-cta-button apple-cta-button--disabled" aria-disabled="true">
                      敬请期待
                    </span>
                  )}
                </div>
              </div>
            </article>
          );
        })}
      </section>
    </main>
  );
};

export default GameLibraryPage;
